var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "POS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.021,
    height: 41.129,
    viewBox: "0 0 25.021 41.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M403.513,132.41h-16.5a4.269,4.269,0,0,0-4.265,4.265v24.093a4.265,4.265,0,0,0,3.666,4.218v4.162a4.4,4.4,0,0,0,4.392,4.392h8.9a4.4,4.4,0,0,0,4.392-4.392v-4.162a4.265,4.265,0,0,0,3.666-4.218V136.674A4.269,4.269,0,0,0,403.513,132.41Zm-14.59,36.738v-4.115h7.8v6.01H390.81a1.9,1.9,0,0,1-1.891-1.9Zm10.8,1.894h-.5v-6.01h2.386v4.115a1.9,1.9,0,0,1-1.893,1.895Zm5.814-10.275a2.02,2.02,0,0,1-2.02,2.02h-16.5a2.02,2.02,0,0,1-2.02-2.02V136.674a2.02,2.02,0,0,1,2.02-2.02h16.5a2.02,2.02,0,0,1,2.02,2.02Z",
    transform: "translate(-382.75 -132.41)",
    fill: "#ec0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M440.51,287.4H456.9V279.39H440.51Zm2.245-5.761h11.9v3.517h-11.9Z",
    transform: "translate(-436.188 -268.393)",
    fill: "#ec0000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 3.143,
    height: 2.243,
    transform: "translate(4.396 20.95)",
    fill: "#ec0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 3.143,
    height: 2.243,
    transform: "translate(10.943 20.95)",
    fill: "#ec0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 3.143,
    height: 2.243,
    transform: "translate(17.49 20.95)",
    fill: "#ec0000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 3.143,
    height: 2.243,
    transform: "translate(4.396 25.14)",
    fill: "#ec0000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 3.143,
    height: 2.243,
    transform: "translate(10.943 25.14)",
    fill: "#ec0000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 3.143,
    height: 2.243,
    transform: "translate(17.49 25.14)",
    fill: "#ec0000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 16.236,
    height: 2.243,
    transform: "translate(4.483 4.45)",
    fill: "#ec0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos);
export default __webpack_public_path__ + "static/media/POS.e279937e0dcef7bf3fe205fe8bcd1b69.svg";
export { ForwardRef as ReactComponent };